import React from 'react';
import styled from 'styled-components';
import GpsButton from '../GpsButton/GpsButton';
import SearchForm from './SearchForm';
import searchGroupContext from '../../../contexts/search-group-context';
import config from '../../../config/config.json';

export default function SearchGroup() {
  return (
    <SearchFormContainer data-test-id="search-group">
      <searchGroupContext.Provider>
        <SearchForm />
        <GpsButton />
      </searchGroupContext.Provider>
      <div id={`${config.searchInputId}-options`} style={{ display: 'none' }} aria-hidden="true" />
      <div id="search-input" style={{ display: 'none' }} aria-hidden="true" />
    </SearchFormContainer>
  );
}

const SearchFormContainer = styled.div`
  max-height: 100%;
  margin: 28px;
  background-color: #fff;

  .search-dealer-field:focus {
    outline: none;
  }

  .search-dealer-field.focus-visible {
    outline: 2px solid dodgerblue;
  }
`;
